var map = {
	"./active-menu.png": "O6mD",
	"./active.png": "KCdI",
	"./ayocpns.png": "CjA3",
	"./ayopppk.png": "xfGg",
	"./ayopppkx.jpg": "0vii",
	"./banner-1.jpg": "Pb69",
	"./banner-2.jpg": "MsBi",
	"./banner-3.jpg": "ctal",
	"./banner-fixed-old.jpg": "Y9BZ",
	"./banner-fixed-ori.jpg": "yBmi",
	"./banner-fixed.jpg": "2J8/",
	"./banner-fixed2.jpg": "nVD1",
	"./banner-fixed3.jpg": "XI7A",
	"./banner-fixed4.jpg": "Bw/Q",
	"./banner-mobile0.jpg": "sdJj",
	"./banner-mobile2.jpg": "FcFE",
	"./banner-mobile20.jpg": "m8GW",
	"./banner-mobile21.jpg": "abHr",
	"./banner-mobile22.jpg": "Jq0c",
	"./banner-mobile23.jpg": "REPx",
	"./banner-ori.jpg": "NLd4",
	"./banner-sample.jpg": "Oc4j",
	"./banner-text-old.png": "mTYG",
	"./banner-text.png": "gLvS",
	"./banner-textnew.jpg": "ajoM",
	"./banner-textnew.png": "Fg7r",
	"./banner-textnew2.png": "/SLb",
	"./banner-textx.png": "zghA",
	"./banner.jpg": "omhf",
	"./banner0.jpg": "vYfW",
	"./banner1.jpg": "NvTC",
	"./banner2.jpg": "7/Ek",
	"./beauty-care-therapy.png": "ZzLp",
	"./books.jpg": "jk0I",
	"./c1.jpg": "97gN",
	"./c2.jpg": "MYam",
	"./c3.jpg": "Ekiy",
	"./c4.jpg": "8HRH",
	"./c5.jpg": "79KW",
	"./clock-icon-white.png": "fbqR",
	"./clock-icon.png": "Gb99",
	"./counter-bg.jpg": "6NY0",
	"./counter.png": "8oEv",
	"./course.jpg": "3pmG",
	"./course.png": "O4w2",
	"./cs.jpg": "caac",
	"./cs2.jpg": "/Zki",
	"./enroll-01.jpg": "vnoV",
	"./enrolment-bg.jpg": "ckKA",
	"./favicon-ds.png": "O5r7",
	"./favicon.png": "06CR",
	"./footer-bg.png": "a1TC",
	"./footer.jpg": "v5Mo",
	"./hero-bg.png": "IOzW",
	"./hours-icon.png": "VExU",
	"./icon-01.png": "d0n1",
	"./icon-02.png": "0S8I",
	"./icon-03.png": "MOFD",
	"./img-01.jpg": "csuN",
	"./img-02.jpg": "iVX4",
	"./img-03.jpg": "bCtQ",
	"./img-04.jpg": "M3N7",
	"./login-banner.png": "XeWC",
	"./logo-ds.png": "zxSV",
	"./logo-icon.png": "56XT",
	"./logo.png": "dLd/",
	"./marker.png": "eSNv",
	"./mike.png": "4gnu",
	"./product4.jpg": "hZ5B",
	"./registration.jpg": "CW5H",
	"./slider-arrow-left.png": "fO/3",
	"./slider-arrow-right.png": "6ppL",
	"./sss1.png": "3b6y",
	"./student-icon.png": "dG65",
	"./towel-set-bathing-therapy.png": "ugbq",
	"./tri-color-leaves.png": "idcj",
	"./user.jpg": "1Bnj",
	"./user.png": "Gvv4",
	"./user2.jpg": "7zXz",
	"./video-call.jpg": "Kzgn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6/nj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img nonrecursive \.png$|\.jpg$
// module id = 6/nj
// module chunks = 1